import { useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { usePreviousValue } from '@wix/da-hooks/pkg/usePreviousValue';
import { resetEditorPublishResults } from '../redux/actionCreators';
import { EditorContext } from '../context';
/**
 * Runs a couple cleanup actions whenever the editor's publish result comes back.
 *
 * Relies on all the contexts provided by `<CommentEditorProviders />`,
 * so be sure you have it set up first!
 */
export function usePublishSuccessCleanup(editorId, result, cleanupCallback) {
    var api = useContext(EditorContext).api;
    var dispatch = useDispatch();
    var previousResult = usePreviousValue(result);
    /*
      Call our cleanup callback whenever the result changes.
  
      We might be able to include this in the useEffect below
      but it was separate in the class component and checks the
      previous result.
    */
    useEffect(function () {
        if (result && previousResult !== result) {
            cleanupCallback && cleanupCallback(result);
        }
    }, [result, previousResult, cleanupCallback]);
    /*
      Blur the editor and reset the editor's publish result when
      a result comes back
    */
    useEffect(function () {
        if (result) {
            dispatch(resetEditorPublishResults(editorId));
            api === null || api === void 0 ? void 0 : api.clearEditor(true);
            // Timeout because of weird timing around the editor closing
            // TODO: Remove the need for this timeout
            var timeout_1 = setTimeout(function () { return api === null || api === void 0 ? void 0 : api.blurEditor(); }, 100);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [result, api, dispatch, editorId]);
}
//# sourceMappingURL=usePublishSuccessCleanup.js.map